import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';

import sourceMappingsActions from '../../redux/sourceMappings/actions';
import SourceMappingList from '../../components/SourceMappingList';
import SidebarContainer from '../SidebarContainer';
import DealerNav from '../../components/DealerNav';
import './SourceMappings.scss';

class SourceMappings extends Component {
  componentDidMount() {
    const { dealerId } = this.props.match.params;
    this.props.actions.sourceMappingRequest(dealerId);
  }

  render() {
    const { sourceMappings, dealer } = this.props;
    return (
      <SidebarContainer title={dealer.name} logo={dealer.logo}>
        <div className="source-mappings-table">
          <DealerNav />
          <SourceMappingList
            list={[sourceMappings.sourceMapping]}
            error={sourceMappings.error}
            fetching={sourceMappings.fetching}
          />
        </div>
      </SidebarContainer>
    );
  }
}

SourceMappings.propTypes = {
  sourceMappings: PropTypes.object,
  actions: PropTypes.object,
  dealer: PropTypes.object,
  match: PropTypes.object,
};

const mapStateToProps = ({ sourceMappings, dealers }) => ({
  sourceMappings,
  dealer: dealers.dealer,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      ...sourceMappingsActions,
    },
    dispatch,
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(SourceMappings);
